/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Core_Unavailable_OptionsInputs */

const en_core_unavailable_options = /** @type {(inputs: Core_Unavailable_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unavailable Options`)
};

/**
* | output |
* | --- |
* | "Unavailable Options" |
*
* @param {Core_Unavailable_OptionsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const core_unavailable_options = /** @type {((inputs?: Core_Unavailable_OptionsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Core_Unavailable_OptionsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_core_unavailable_options(inputs)
});